import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en, kr, hn, fr, tg } from './locals';

const savedLanguage = localStorage.getItem('i18nextLng') || 'en';

const resources = {
  en: {
    translation: en,
  },
  kr: {
    translation: kr,
  },
  hn: {
    translation: hn,
  },
  tg: {
    translation: tg,
  },
  fr: {
    translation: fr,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: savedLanguage,
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
